module.exports = __webpack_public_path__ + "static/media/con_ai.5cc9000d.png";